module.exports = __webpack_public_path__ + "img/port-monitoring.e05840e6.png";